// Text from the async Clipboard API (fallback when a paste event carries no data, and the "paste" button).
// readText() rejects with NotAllowedError when the browser denies clipboard access (e.g. iOS Safari),
// which is treated as an empty paste (GAMESTURE-STORE-BR). Missing API → empty string too.
// Paste-event data must still be read synchronously by the caller: preventDefault() after an await is too late.
export async function readClipboardText(): Promise<string> {
  try {
    return (await navigator?.clipboard?.readText?.()) || ''
  } catch {
    return ''
  }
}
